module.exports = __webpack_public_path__ + "assets/img/mecha-active-btn-100af0e9.png";